const jsValidKeyRE = /^[$A-Z_a-z][\w$]*$/

export function getJSValidKey(key: string) {
  return jsValidKeyRE.test(key) ? key : `"${key}"`
}
